import { render } from "./ChallengeTeam.vue?vue&type=template&id=2370c1be&scoped=true"
import script from "./ChallengeTeam.vue?vue&type=script&lang=js"
export * from "./ChallengeTeam.vue?vue&type=script&lang=js"

import "./ChallengeTeam.vue?vue&type=style&index=0&id=2370c1be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2370c1be"]])

export default __exports__